var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipStr),expression:"tooltipStr"}],class:{
		'lba-progress-pie': _vm.type === 'circle',
		'lba-progress-line': _vm.type === 'line',
	},style:(_vm.background),attrs:{"parentComponentId":_vm.currentComponentId}},[_c('span',[_vm._v(_vm._s(_vm.value)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }